import { Component, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
// Plugins
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { generatePassword } from 'password-generator-ts';
// Models
import { Response } from '@models/api/api.model';
import { GroupUserData } from '@models/group-user/group-user.model';
// Services
import { UserService } from '@services/user/user.service';

@Component({
	selector: 'sf-reset-password-modal',
	templateUrl: './reset-password-modal.component.html',
	styleUrls: ['./reset-password-modal.component.scss']
})
export class ResetPasswordModalComponent implements OnInit {

	public user: GroupUserData = inject(NZ_MODAL_DATA);
	public form: FormGroup<{ password: FormControl }> = null;
	public password: string = '';
	public loading: boolean = false;

	public constructor(
		private modalRef: NzModalRef,
		private userService: UserService,
	) { }

	public ngOnInit(): void {
		this.setForm();
	}

	public generatePassword(): void {
		this.form.controls.password.patchValue(
			generatePassword(10, { lowercases: true, uppercases: true, numbers: true, symbols: false })
		);
	}

	public reset(): void | boolean {
		if (this.loading || this.form.invalid) return false;

		this.setLoading(true);

		this.userService.resetPassword(this.user?.uuid_tUser || this.user?.uuid, this.form.controls.password.value).subscribe(
			(res: Response): void | boolean  => {
				if (!res?.result) return false;

				this.destroyModal();
			}
		).add(() => this.setLoading(false));
	}

	public destroyModal(): void {
		this.modalRef.destroy();
	}

	private setForm(): void {
		this.form = new FormGroup({
			password: new FormControl('', Validators.required)
		});
	}

	private setLoading(state: boolean): void {
		this.loading = state;
		this.modalRef.updateConfig({
			nzMaskClosable: !state,
			nzClosable: !state
		});
	}
}